import { createBrowserHistory } from 'history';
import { PUBLIC_URL } from '../config';
import formPathWithSearchParams, { IFormPathWithSearchParams } from "../utils/formPathWithSearchParams";

const appHistory = createBrowserHistory({ basename: PUBLIC_URL });

export const appHistoryPushWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = ''): void => {
    appHistory.push(formPathWithSearchParams(params, pathname));
}

export const appHistoryReplaceWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = ''): void => {
    appHistory.replace(formPathWithSearchParams(params, pathname));
}

export type IHistoryLocation = typeof appHistory.location;

export default appHistory;
